"use client";

import styles from "./styles.module.scss";
import { IoMdClose } from "react-icons/io";
import { BsChevronRight } from "react-icons/bs";
import { useCookies } from "react-cookie";
import Marquee from "react-fast-marquee";
import { usePathname } from "next/navigation";

declare const performance:any;

interface TopHeaderProps {
  topHeader: any; 
}

export const TopHeader = ({ topHeader }:TopHeaderProps) => 
{
    const pathname 				= usePathname();
    const hasTopHeader: boolean = [ "/" ].includes(
        pathname
    )    
    const [ cookies, setCookie ] = useCookies([ "topBarVisible" ]);

    const onClose = () => 
    {
        const currentTimeMs = performance.now();
        const expiresTimeMs = currentTimeMs + 24 * 60 * 60 * 1000; // + 24 horas
        const expires		= new Date(expiresTimeMs);

        setCookie("topBarVisible", "close", { path : "/", expires });
    };
  
    return (
        <>
            {hasTopHeader && !cookies.topBarVisible && (
                <header className={styles.topBar}>
                    <div className={styles.content}>
                        <IoMdClose onClick={() => onClose()} />
                        <Marquee className={styles.marquee} play={true}>
                            {topHeader?.list?.map((item: any, index: any) => (
                                <small key={index}>{item?.name}&nbsp;</small>
                            ))}
                        </Marquee>
                        <BsChevronRight />
                    </div>
                </header>
            )}            
        </>
    );
};
